<template>
  <div class="flex flex-col">
    <div
      :id="id"
      class="flex w-full justify-between items-center"
      @click="toggle"
      tabindex="0"
      @keyup.enter="toggle"
      @keyup.space="toggle"
      role="button"
    >
      <h1 class="flex items-center gap-1">
        <span class="text-base font-bold">{{ title }}</span>
        <RequiredChar v-if="required" />
        <Icon v-if="error" icon="error" color="red" />
      </h1>
      <Button
        text=""
        :leftIcon="open ? 'arrow-less' : 'arrow-down'"
        secondaryButton
        leftIconSize="26px"
        class="border-none"
      />
    </div>
    <div v-show="open" class="block">
      <slot />
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import Button from "../Form/Button/Button.vue";
import Icon from "../Iconography/Icon/Icon.vue";
import RequiredChar from "../Typography/RequiredChar.vue";

const props = defineProps({
  title: String,
  error: Boolean,
  required: Boolean,
});
const open = ref(false);
const id = `${props.title.replace(" ", "").toLocaleLowerCase()}-collapse`;
const toggle = () => {
  if (!open.value) {
    document.getElementById(id).scrollIntoView({ behavior: "smooth" });
  }
  open.value = !open.value;
};
</script>
